// @flow
import alt from '../alt';

import NotificationActions from '../actions/NotificationActions';

import _ from 'underscore';
import t from '../trans';
import SoftwareUpdateActions from "../actions/SoftwareUpdateActions";
import SoftwareUpdateSource from "../sources/SoftwareUpdateSource";

/**
 * Konfiguratsiooni haldamise store
 *
 * Olekudiagramm: PROCESSING -> OK / FAIL
 *
 */
class SoftwareUpdateStore {
    constructor() {
        this.state = {
            auth: false,
            user: null,
            passwd: null,
            state: "OK",
            action: null,
            firmwareInfo: {}
        };
        this.bindActions(SoftwareUpdateActions);
        this.exportAsync(SoftwareUpdateSource);
    }

    /**
     * Toote laadimise käivitamine
     */
    onFetchSoftwareInfo(info) {
        if (info == null) info = {user: this.state.user, passwd: this.state.passwd};
        this.setState({action: "fetchSoftwareInfo", state: "PROCESSING", user: info.user, passwd: info.passwd});
        let p = this.getInstance().fetchSoftwareInfo(info.user, info.passwd);
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function () {});
    }

    /**
     * Toote laadimine ebaõnnestus
     */
    onFetchSoftwareInfoFailed(error) {
        this.processError(error);
    }

    onFetchSoftwareInfoDone(response) {
        try {
            if (!_.has(response.data, 'firmwareInfoResult')) throw t("Server error");
            if (response.data.firmwareInfoResult == null) this.setState({firmwareInfo: {}, auth: true, state: "OK"});
            else this.setState({firmwareInfo: response.data.firmwareInfoResult, auth: true, state: "OK"});
        } catch (e) {
            if (!_.isString(e)) {
                console.log(e.toString());
                NotificationActions.error.defer(t("Server error"));
            }
            else NotificationActions.error.defer(e);
            this.setState({state: "FAIL"});
        }
    }

    /**
     * Toote laadimise käivitamine
     */
    onUpdate(params) {
        this.setState({action: "update", state: "PROCESSING"});
        let p = this.getInstance().update(params.file, params.user, params.passwd);
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function () {});
    }

    /**
     * Toote laadimine ebaõnnestus
     */
    onUpdateFailed(error) {
        this.processError(error);
    }

    processError(error) {
        let message = t('Server error');
        if (error.response) {
            if (error.response.data && error.response.data.error && error.response.data.error.message) {
                message = error.response.data.error.message;
            } else {
                switch (error.response.status) {
                    case 403:
                        message = t("Invalid password");
                        break;
                    case 503:
                        message = t("Service unavailable");
                        break;
                    default:
                        message = t("Server error");
                }
            }
            switch (error.response.status) {
                case 403:
                    this.setState({auth: false, state: "FAIL"});
                    break;
                default:
                    this.setState({state: "FAIL"});
            }
        } else {
            this.setState({state: "FAIL"});
        }
        NotificationActions.error.defer(message);
    }

    onUpdateDone(response) {
        NotificationActions.success.defer(t('Software version updated'));
        this.setState({auth: true, state: "OK"});
    }

    onRestore(params) {
        this.setState({action: "restore", state: "PROCESSING"});
        let p = this.getInstance().restore(params.user, params.passwd);
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function () {});
    }

    onRestoreFailed(error) {
        this.processError(error);
    }

    onRestoreDone() {
        NotificationActions.success.defer(t('Software previous version restored'));
        this.setState({auth: true, state: "OK"});
    }

    /**
     * Parameetri muutmine
     */
    onChangeValue(info) {
        if (!this.validateValue(info)) return;

        let newConfig = _.clone(this.state.config);
        let isChanged = false;

        switch (info.field) {
            default:
                break;
        }
        newConfig[info.field] = info.value;
        if (newConfig[info.field] !== this.state.config[info.field]) isChanged = true;

        if (!isChanged) return;

        switch (info.field) {
            default:
                break;
        }

        this.setState({
            config: newConfig
        });
    }

    validateValue(info) {
        switch (info.field) {
            default:
                break;
        }
        return true;
    }

}

export default alt.createStore(SoftwareUpdateStore, 'SoftwareUpdateStore');
